<template>

    <form ref="estagio-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-6">
                <label for="nome">Nome</label>
                <input type="text" class="form-control" name="nome" placeholder="" v-model="model.nome" required />
            </div>
            <div class="form-group col-md-2">
                <label for="sigla">Sigla</label>
                <input type="text" class="form-control" name="sigla" placeholder="" v-model="model.sigla" required />
            </div>
            <div class="form-group col-md-4">
                <label for="externalId">External ID</label>
                <input type="text" class="form-control" name="externalId" placeholder="External ID" v-model="model.externalId" />
            </div>
            <div class="form-group col-md-12">
                <label for="nivelId">Nível</label>
                <select v-select="{ dataitem: 'Nivel', default: 'Selecione' }" v-model="model.nivelId" class="form-control" name="nivelId" required></select>
            </div>
            <div class="form-group col-md-4">
                <label for="publicoAlvoMinimo">Idade do Público Alvo Mínimo</label>
                <input type="text" class="form-control" name="publicoAlvoMinimo" placeholder="" v-model="model.publicoAlvoMinimo" required />
            </div>
            <div class="form-group col-md-4">
                <label for="publicoAlvoMaximo">Idade do Público Alvo Máximo</label>
                <input type="text" class="form-control" name="publicoAlvoMaximo" placeholder="" v-model="model.publicoAlvoMaximo" required />
            </div>
            <div class="form-group col-md-4">
                <label for="vagasMinima">Vagas Mínima</label>
                <input type="text" class="form-control" name="vagasMinima" placeholder="" v-model="model.vagasMinima" required />
            </div>
            <div class="form-group col-md-4">
                <label for="vagasMaxima">Vagas Máxima</label>
                <input type="text" class="form-control" name="vagasMaxima" placeholder="" v-model="model.vagasMaxima" required />
            </div>
            <div class="form-group col-md-4">
                <label for="ordem">Ordem</label>
                <input type="text" class="form-control" name="ordem" placeholder="" v-model="model.ordem" />
            </div>
            <div class="form-group col-md-4">
                <label for="tempoGapConteudo">TempoGapConteudo</label>
                <input type="text" class="form-control" name="tempoGapConteudo" placeholder="" v-model="model.tempoGapConteudo" />
            </div>
            <div class="form-group col-md-4">
                <label for="mediaAprovacao">Média Para Aprovação</label>
                <input type="number" class="form-control" name="mediaAprovacao" placeholder="" v-model="model.mediaAprovacao" required />
            </div>
            <div class="form-group col-md-4">
                <label for="duracao">Duração</label>
                <input type="number" class="form-control" name="duracao" placeholder="" v-model="model.duracao" required />
            </div>
            <div class="form-group col-md-4">
                <label for="fatorAvaliacao">Fator Avaliação</label>
                <input type="number" class="form-control" name="fatorAvaliacao" placeholder="" v-model="model.fatorAvaliacao" required />
            </div>
            <div class="form-group col-md-4" id="ModeloBoletimId" name="ModeloBoletimId">
                <label for="ModeloBoletim">Modelo do Boletim</label>

                <b-form-select name="ModeloBoletim" v-model="model.modeloBoletimId" required>
                    <option :value="undefined" disabled selected> Selecione</option>
                    <option :value="1">Nota</option>
                    <option :value="2">Conceito</option>
                </b-form-select>

                <!--<select class="form-control" name="ModeloBoletim" v-model="model.modeloBoletimId" required>
            <option value="" disabled selected>Selecione</option>
            <option value="1">Nota</option>
            <option value="2">Conceito</option>
        </select>-->

            </div>
            <div class="form-group col-md-2">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ativo" class="custom-control-input" v-model="model.ativo">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativo?</span>
                </label>
            </div>
            <div class="form-group col-md-2">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="inicial" class="custom-control-input" v-model="model.inicial" @click="verficarFinal">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description" v-b-tooltip.hover title="O estágio não poderá ser Inicial e Final simultaneamente"> Inicial?</span>
                </label>
            </div>
            <div class="form-group col-md-2">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="final" class="custom-control-input" v-model="model.final" @click="verificarInicial">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description" v-b-tooltip.hover title="O estágio não poderá ser Inicial e Final simultaneamente"> Final?</span>
                </label>
            </div>
            <div class="form-group col-md-6">
                <div class="clearfix"></div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="avaliacaoPorConceito" class="custom-control-input" v-model="model.avaliacaoPorConceito" @click="alteraCamposFrequencia()">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Avaliação Por Conceito?</span>
                </label>
            </div>
            <div class="form-group col-md-6">
                <label for="valorRepasseConecta">Valor do Repasse por Estágio (CNA Conecta)</label>
                <vue-numeric separator="." v-bind:precision="2" v-bind:max="9999999.99" placeholder="0.00" id="valorRepasseConecta" type="text" class="form-control" v-model="model.valorRepasseConecta" required />
            </div>
            <div class="form-group col-md-6">
                <div class="clearfix"></div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="podeCriarTurma" class="custom-control-input" v-model="model.podeCriarTurma">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Pode Criar Turma?</span>
                </label>
            </div>
            <div class="form-group col-md-6">
                <label for="valorTaxaCNA">Valor Taxa (CNA Conecta)</label>
                <vue-numeric separator="." v-bind:precision="2" v-bind:max="9999999.99" placeholder="0.00" id="valorTaxaCNA" type="text" class="form-control" v-model="model.valorTaxaCNA" required />
            </div>

            <div class="form-group col-md-12 row">
                <div class="form-group col-md-6">
                    <label>
                        Percentual Mínimo para Aprovação Via Conselho Aproveitamento
                        <span v-b-tooltip.hover
                              title=" Percentual mínimo que o aluno deve obter no estágio para que seja possível solicitar aprovação via conselho">
                            <i class="fa fa-info-circle"></i>
                        </span>
                    </label>
                    <vue-numeric separator="." v-bind:precision="2" placeholder="0.00" id="aproveitamentoMinimo" class="form-control" :disabled=model.avaliacaoPorConceito v-model="model.aproveitamentoMinimo" />
                </div>
                <div class="form-group col-md-6">
                    <label>
                        Percentual Mínimo para Aprovação Via Conselho Frequência
                        <span v-b-tooltip.hover
                              title=" Percentual mínimo que o aluno deve obter no estágio para que seja possível solicitar aprovação via conselho">
                            <i class="fa fa-info-circle"></i>
                        </span>
                    </label>
                    <vue-numeric separator="." v-bind:precision="2" placeholder="0.00" id="frequenciaMinima" type="text" class="form-control" :disabled=model.avaliacaoPorConceito v-model="model.frequenciaMinima" />
                </div>
            </div>

            <div class="form-group col-md-12">
                <div class="clearfix"></div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ativoCNANet" class="custom-control-input" v-model="model.ativoCNANet">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">Bloquear Lançamento de Notas para Alunos Sem Chave Ativa?</span>
                </label>
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix"></div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="estagioIndiceRematricula" class="custom-control-input" v-model="model.estagioIndiceRematricula">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">Deseja considerar este estagio no indice de rematricula?</span>
                </label>
            </div>
            <div class="form-group col-md-8">
                <div class="clearfix"></div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="planoDeAulaConsideraRecesso" class="custom-control-input" v-model="model.planoDeAulaConsideraRecesso">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Considerar Calendário de Recesso?</span>
                </label>
            </div>
            <div class="form-group col-md-6">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="participaCommerce" class="custom-control-input" v-model="model.participaCommerce">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Estágio Participa do CNA Commerce?</span>
                </label>
            </div>
            <div class="form-group col-md-6">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="participaCommerce" class="custom-control-input" v-model="model.utilizaContratoDiferenciado">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Utiliza Contrato Diferenciado?</span>
                </label>
                <label for="publicoAlvoMinimo">ID Contrato</label>
                <input type="text" class="form-control" name="contratoDiferenciadoPadraoId" placeholder="ID Contrato Nº" v-model="model.contratoDiferenciadoPadraoId" />
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    import Auth from '@/common/auth'


    export default {
        name: "estagio-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            user: {
                escolas: []
            },

            form: "estagio-form-edit",

            resources: {
                edit: 'estagio',
            },

            verificarInicial: function () {

                if (document.getElementsByName('inicial')[3].checked == true && document.getElementsByName('final')[3].checked == true) {
                    //('Não é possivel o Estágio ser Inicial e Final simultaneamente');
                    document.getElementsByName('inicial')[3].click();
                }
            },

            verficarFinal: function () {
                if (document.getElementsByName('inicial')[3].checked == true && document.getElementsByName('final')[3].checked == true) {
                    //alert('Não é possivel o Estágio ser Inicial e Final simultaneamente');
                    document.getElementsByName('final')[3].click();
                }

            },

            defineColaborador(model) {
                model.colaboradorId = this.user.Id;
                model.nomeColaborador = this.user.name
            },

            defineEscola(model) {
                var escola = this.user.escolas[0];
                model.escolaId = escola.escolaId;
                model.nomeEscola = escola.nomeEscola
            },

            alteraCamposFrequencia: function () {
                let campoFrequenciaMinima = document.querySelector("#frequenciaMinima");
                let campoAproveitamentoMinimo = document.querySelector("#aproveitamentoMinimo");

                this.model.frequenciaMinimas = 0;
                campoFrequenciaMinima.toggleAttribute('disabled');

                this.model.aproveitamentoMinimo = 0;
                campoAproveitamentoMinimo.toggleAttribute('disabled');
            }
        }),
        methods: {

            executeEdit: function (model) {

                if (document.getElementsByName('inicial')[3].checked == true && document.getElementsByName('final')[3].checked == true) {
                    this.defaultErrorResult('Não é possivel o Estágio ser Inicial e Final simultaneamente');
                    return;
                }

                if (this.formValidate() == false) return;

                this.defineColaborador(model);
                this.defineEscola(model);

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            this.showLoading();

            this.user = Auth.currentUser();

            new Api(this.resources.edit).get({ estagioId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
                this.hideLoading();
            }, err => {
                this.hideLoading();
                this.defaultErrorResult(err);
            })
        }
    };
</script>